<template>
  <teleport to="head">
    <component :is="'script'" type="application/ld+json">
    {
      "@context": "https://schema.org/",
      "@type": "BlogPosting",
      "mainEntityOfPage": {
        "@type": "WebPage",
        "@id": "{{ slug_url }}"
      },
      "headline": "{{ headline }}",
      "description": "{{ description }}",
      "image": {
        "@type": "ImageObject",
        "url": "{{ image_url }}",
        "width": "{{ image_width }}",
        "height": "{{ image_height }}"
      },
      "author": {
        "@type": "Organization",
        "name": "{{ publisher }}",
        "url": "{{ publisher_url }}"
      },
      "publisher": {
        "@type": "Organization",
        "name": "{{ publisher }}",
        "logo": {
          "@type": "ImageObject",
          "url": "{{ logo_url }}",
          "width": "{{ logo_width }}",
          "height": "{{ logo_height }}"
        }
      },
      "datePublished": "{{ date_published }}",
      "dateModified": "{{ date_modified }}"
    }
    </component>
  </teleport>
</template>
<script>

export default {
  name: 'SchemaOrgArticle',
  props: {
    description: {
      type: String,
      default: ''
    },
    image_url: {
      type: String,
      default: 'https://umzug-bayern.com/img/logo.webp'
    },
    image_width: {
      type: String,
      default: '510'
    },
    image_height: {
      type: String,
      default: '510'
    },
    logo_url: {
      type: String,
      default: 'https://umzug-bayern.com/img/logo.webp'
    },
    logo_width: {
      type: String,
      default: '510'
    },
    logo_height: {
      type: String,
      default: '510'
    },
    headline: {
      type: String,
      default: 'umzug-bayern.com'
    },
    slug_url: {
      type: String,
      default: 'https://umzug-bayern.com'
    },
    date_published: {
      type: String,
      default: '2022-12-18'
    },
    date_modified: {
      type: String,
      default: '2022-12-18'
    },
    publisher: {
      type: String,
      default: 'umzug-bayern.com'
    },
    publisher_url: {
      type: String,
      default: 'https://umzug-bayern.com'
    }

  },
  components: {
  },
  data() {
    return {

    };
  },
  methods: {
    onSubmit() {

    }
  },
  computed: {

  }
}
</script>
